import { Box, Typography, Alert } from '@mui/material';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { useDispatch, useSelector } from 'react-redux';
import { changeTheme } from 'src/redux-store/slices/themeSlice';
import { RootState } from 'src/redux-store/appStore';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { httpRequest } from 'src/services/httpRequest';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useState } from 'react';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import ImageUploadPreview from './ImageUploadPreview';

const ConfigurationTheme: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { townshipId } = useParams<{ townshipId: string }>();
  const [selectedLogo, setSelectedLogo] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const initialValue = {
    logo: useSelector((store: RootState) => store.theme.themeLogo),
    colour: useSelector((store: RootState) => store.theme.themeColor)
  };

  const allFields: Fields[] = [
    {
      fieldName: 'updatetheme',
      fieldLabel: 'Theme Color',
      fieldType: 'colorPicker',
      initialValue: initialValue?.colour
    }
  ];

  const handleSubmitTheme = async (
    color: string,
    logoName: string,
    logoUrl: string
  ) => {
    const response = await httpRequest(
      'POST',
      `/configuration/updateThemeAndLogo`,
      {
        Logo: logoName,
        Theme: color
      }
    );
    if (response?.status === 'success') {
      dispatch(changeTheme({ updatetheme: color, uploadLogo: logoUrl }));
      toast.success('The application theme has been updated successfully.');
      setLoading(false);
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
      setLoading(false);
    }
  };

  async function handleSubmit(value: any) {
    if (selectedLogo === null) {
      handleSubmitTheme(value.updatetheme, '', initialValue?.logo);
      return;
    }
    value.uploadLogo = selectedLogo;
    setLoading(true);
    const formData = new FormData();
    formData.append('uploadLogo', value.uploadLogo);
    const response = await httpRequest(
      'POST',
      `/uploadPDF/uploadLogo`,
      formData,
      { 'Content-type': 'multipart/form-data' }
    );
    if (response?.status === 'success') {
      handleSubmitTheme(
        value.updatetheme,
        response.data?.fileName,
        response.data?.downloadURL
      );
    } else {
      setLoading(false);
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  }

  function handleCancel() {
    navigate(`/dashboard/${townshipId}`);
  }

  return (
    <Box m={{xs:1, sm:3}}>
      {loading && <LoadingOverlay />}
      <Typography variant="h4" mb={3}>
        <Alert severity="info">
          Changing the permit theme will apply the new design to all permits
          across the entire township. Please review the theme settings carefully
          before applying to ensure consistency and alignment with township
          preferences.
        </Alert>
      </Typography>
      <Typography
        variant="h3"
        mb={3}
        color={useSelector((store: RootState) => store.theme.themeColor)}
      >
        Change Township Theme
      </Typography>

      <FormikForm
        allFields={allFields}
        buttonTitle={['Cancel', 'Save']}
        isNotDisable={true}
        content={
          <ImageUploadPreview
            initialValue={initialValue?.logo}
            setSelectedLogo={setSelectedLogo}
          />
        }
        formMethod={handleSubmit}
        handleOtherButton={handleCancel}
      />
    </Box>
  );
};

export default ConfigurationTheme;
